import React, { useState, useEffect } from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Loading, MasterButton } from "App/Component/ui"
import { TaxIcon, FileOpenIcon, DiscountIcon } from "App/Assets/index"
import { ModalSimpan, ModalTax } from ".."
import { FORM_RESET_STATE_WMS_PO } from "../../helpers"
import { useContext } from "react"
import { FormContext } from "../../context/FormContext"
import {
  convertToValidPrice,
  formatNumber,
  isNull,
  removeLocalStorageAsFormData,
} from "App/utils/helpers"
import { BASE_URL_4, instance4, WMS_LGS_PO } from "App/constants"
import fileDownload from "js-file-download"
import ModalPotongan from "../ModalPotongan/ModalPotongan"
import { itSelfEmpty } from "utils/all"
// import { printDoc } from "App/utils/helpers";

const useStyles = makeStyles({
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "10px",
    borderBottom: "1.5px dashed #333333",
  },
})

export default function Perhitungan({
  setListPO,
  setNewDataPoList,
  // perhitungan,
  listPO,
}) {
  const classes = useStyles()
  const [showModalSimpan, setShowModalSimpan] = useState(false)
  const [showModalPotongan, setShowModalPotongan] = useState(false)
  const [showModalTax, setShowModalTax] = useState(false)
  const [tempJumlah, setTempJumlah] = useState(0)
  const [loading, setLoading] = useState(false)
  const [perhitungan, setPerhitungan] = useState({
    jumlah: 0,
    potongan: 0,
    tax: 0,
    total_jumlah: 0,
  })
  const { formData, setFormData, setRowsRekomendasi } = useContext(FormContext)

  useEffect(() => {
    ;(async () => {
      await setPerhitunganListPO()
    })()
  }, [listPO.length, listPO, formData.jumlah, formData.total_jumlah, formData.tax]) // eslint-disable-line react-hooks/exhaustive-deps

  async function setPerhitunganListPO() {
    let jumlah = 0
    await listPO.map((e) => {
      const subJumlah = e?.harga * e?.qty
      const nilaiDisc = (parseFloat(e?.disc) / 100) * subJumlah
      return (jumlah += subJumlah - nilaiDisc)
    })

    const potongan = convertToValidPrice(formData.potongan2)
    const subTotal = jumlah-potongan;
    let tax = (parseFloat(formData.tax) / 100) * subTotal
    setTempJumlah(jumlah)
    setPerhitungan({
      jumlah,
      tax: tax,
      potongan: potongan,
      total_jumlah: subTotal + tax,
    })
  }

  function resetForm() {
    setFormData(FORM_RESET_STATE_WMS_PO)
    removeLocalStorageAsFormData(WMS_LGS_PO)
    setListPO([])
    setRowsRekomendasi([])
  }

  function strReplace(str) {
    var newStr = ""
    for (var i = 0; i < str.length; i++) {
      if (str[i] === "/") {
        newStr += "_"
      } else {
        newStr += str[i]
      }
    }
    return newStr
  }

  const downloadPDF = async (id, name) => {
    setLoading(true)
    let filename = ""
    if (isNull(name)) {
      filename = "Purchase_Order"
    } else {
      filename = strReplace(name)
    }

    try {
      const api = await instance4.get(
        `${BASE_URL_4}/wmsPoLogistik/po/download_pdf/${id}`,
        {
          responseType: "blob",
        },
      )
      fileDownload(api.data, filename + ".pdf")
    } catch (error) {
      return {
        state: false,
        message: error?.response?.data?.message,
      }
    }
    setLoading(false)
  }

  return (
    <>
      {showModalSimpan && (
        <ModalSimpan
          setShowModal={() => setShowModalSimpan(false)}
          resetForm={() => resetForm()}
          setNewDataPoList={setNewDataPoList}
          listPO={listPO}
          setListPO={setListPO}
        />
      )}

      {showModalPotongan && (
        <ModalPotongan
          setShowModal={() => setShowModalPotongan(false)}
          setNewDataPembelianList={setNewDataPoList}
          getPerhitunganListPembelian={setPerhitunganListPO}
          tempJumlah={tempJumlah}
        />
      )}

      {showModalTax && (
        <ModalTax
          setListPO={setListPO}
          setShowModal={() => setShowModalTax(false)}
          setNewDataPoList={setNewDataPoList}
        />
      )}

      <div>
        <p className="fw-600 mb-1 mt-1">Perhitungan</p>
      </div>
      <Loading show={loading} />
      <div>
        <div style={{ width: "50%" }}>
          <table
            width="100%"
            style={{
              lineHeight: "2rem",
            }}
          >
            <tbody>
              <tr>
                <td width="40%">Jumlah</td>
                <td width="5%">:</td>
                <td width="5%">Rp. </td>
                <td width="50%" align="right">
                  {isNull(perhitungan.jumlah)
                    ? "0"
                    : formatNumber(perhitungan?.jumlah)}
                </td>
              </tr>
              <tr>
                <td width="40%">Potongan</td>
                <td width="5%">:</td>
                <td width="5%">Rp. </td>
                <td width="50%" align="right">
                  {isNull(perhitungan.potongan)
                    ? "0"
                    : formatNumber(perhitungan?.potongan)}
                </td>
              </tr>
              <tr>
                <td colSpan="2"></td>
                <td colSpan="2" className={classes.border}></td>
              </tr>
              <tr>
                <td width="40%">Sub Total</td>
                <td width="5%">:</td>
                <td width="5%">Rp. </td>
                <td width="50%" align="right">
                  {formatNumber(
                    itSelfEmpty(perhitungan?.jumlah, 0) -
                      itSelfEmpty(perhitungan.potongan),
                  )}
                </td>
              </tr>
              <tr>
                <td width="40%">Tax ({formData.tax}%)</td>
                <td width="5%">:</td>
                <td width="5%">Rp. </td>
                <td width="50%" align="right">
                  {isNull(perhitungan?.tax)
                    ? "0"
                    : isNaN(perhitungan.tax)
                    ? 0
                    : formatNumber(perhitungan?.tax)}
                </td>
              </tr>

              <tr>
                <td colSpan="2"></td>
                <td colSpan="2" className={classes.border}></td>
              </tr>

              <tr>
                <td width="40%" className="pt-1">
                  Total Jumlah
                </td>
                <td width="5%">:</td>
                <td width="5%">Rp. </td>
                <td width="50%" align="right">
                  {isNull(perhitungan.total_jumlah)
                    ? "0"
                    : isNaN(perhitungan.total_jumlah)
                    ? 0
                    : formatNumber(perhitungan.total_jumlah)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-1">
          <div
            className="mt-1"
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "20px",
              }}
            >
              {!formData.isProcess && (
                <>
                <MasterButton
                  type={"button"}
                  color="green"
                  name="Tax"
                  size="lg"
                  onClick={() => setShowModalTax(!showModalTax)}
                  withIcon={true}
                  icon={<TaxIcon width="12px" height="15px" />}
                />
                   <MasterButton
                      type={"button"}
                      color="green"
                      name="Potongan"
                      onClick={() => {
                        setPerhitunganListPO()
                        setShowModalPotongan(!showModalPotongan)
                      }}
                      size="sm"
                      withIcon={true}
                      icon={<DiscountIcon width="20px" height="20px" />}
                    />
                </>
              )}

              <MasterButton
                type={"button"}
                // color='warning'
                color="secondary"
                name="Cetak"
                size="lg"
                withIcon={true}
                disabled={true}
                icon={<FileOpenIcon width="18px" height="18px" />}
              />
              {!isNull(formData.idpo) && (
                <MasterButton
                  type={"button"}
                  color="warning"
                  name="Export PDF"
                  onClick={() => {
                    downloadPDF(formData.idpo, formData.nomorPO)
                  }}
                  // onClick={() => {
                  //   printDoc(
                  //     "export-purchase-order",
                  //     `Purchase Order ID ${formData.idpo}`
                  //   );
                  // }}
                  size="lg"
                  withIcon={true}
                  icon={<FileOpenIcon width="18px" height="18px" />}
                />
              )}
            </div>
            <div
              style={{
                display: "flex",
                gap: "20px",
              }}
            >
              {!formData.isProcess && (
                <MasterButton
                  type={"button"}
                  color="lightgreen"
                  name="Simpan"
                  size="lg"
                  onClick={() => setShowModalSimpan(!showModalSimpan)}
                  withIcon={true}
                  icon={<TaxIcon width="12px" height="15px" />}
                />
              )}

              <MasterButton
                type={"button"}
                color="danger"
                name="Reset"
                onClick={() => resetForm()}
                size="lg"
                withIcon={true}
                icon={<FileOpenIcon width="18px" height="18px" />}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
